<template>
  <div class="register">
    <el-row type="flex">
      <el-col class="hidden-md-and-down" :span="10">
        <img :src="image" alt="" style="width: 100%" />
      </el-col>
      <el-col :sm="24" :lg="14">
        <div class="login-section">
          <el-row>
            <el-col :sm="12" :lg="12">
              <h3>會員註冊</h3>
            </el-col>
            <el-col :sm="12" :lg="12">
              <p class="w3-right">
                已經有賬號?
                <router-link to="/login" class="my-login-link"
                  >登入</router-link
                >
              </p>
            </el-col>
          </el-row>

          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            label-position="top"
            class="w3-margin-top"
          >
            <el-row justify="space-between">
              <el-col :sm="24" :lg="11">
                <el-form-item label="姓氏" prop="lastName">
                  <el-input
                    v-model.trim="ruleForm.lastName"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="11">
                <el-form-item label="名字" prop="firstName">
                  <el-input
                    v-model.trim="ruleForm.firstName"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row justify="space-between">
              <el-col :sm="24" :lg="11">
                <el-form-item label="電郵地址" prop="email">
                  <el-input v-model.trim="ruleForm.email" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="11">
                <el-form-item label="電話" prop="telephone">
                  <el-input
                    v-model.number="ruleForm.telephone"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row justify="space-between">
              <el-col :sm="24" :lg="11">
                <el-form-item label="密碼" prop="password">
                  <el-input
                    v-model.trim="ruleForm.password"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="11">
                <el-form-item label="確認密碼" prop="confirmPassword">
                  <el-input
                    v-model.trim="ruleForm.confirmPassword"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row justify="space-between">
              <el-col :sm="24" :lg="11">
                <el-form-item label="出生日期" prop="date1">
                  <el-date-picker
                    v-model="ruleForm.date1"
                    type="date"
                    placeholder="Pick a day"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :lg="11">
                <el-form-item label="出生日期" prop="date2">
                  <el-date-picker
                    v-model="ruleForm.date2"
                    type="date"
                    placeholder="Pick a day"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :sm="24">
                <el-form-item>
                  <el-checkbox
                    label="我同意‌·易到家 Etouka《 使用條款及免責聲明 》及《
                    私隱政策聲明 》"
                  ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button @click="submitForm" class="my-btn-register"
              >送出</el-button
            >
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";
import LeftImage from "../assets/left-img.png";
// import Schema from "async-validator";

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please, input the password"));
      } else {
        if (this.ruleForm.confirmPassword !== "") {
          this.$refs.ruleForm.validateField("confirmPassword");
        }
        callback();
      }
    };

    const validateConfirmPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else {
        if (value !== this.ruleForm.password) {
          callback(new Error("Password and Confirm password do not match!"));
        } else {
          callback();
        }
      }
    };

    return {
      image: LeftImage,
      ruleForm: {
        lastName: "",
        firstName: "",
        email: "",
        telephone: "",
        password: "",
        confirmPassword: "",
        date1: null,
        date2: null,
      },
      rules: {
        lastName: [
          {
            required: true,
            message: "Last Name cannot be empty",
            trigger: "blur",
          },
        ],
        firstName: [
          {
            required: true,
            message: "First Name cannot be empty",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            type: "email",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "Password must be between 6 to 16 characters",
          },
        ],
        confirmPassword: [
          {
            required: true,
            validator: validateConfirmPass,
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            trigger: "blur",
            message: "Telephone is required",
          },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "Pick a date",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "Pick a date",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // alert("submit");
          ElNotification({
            title: "Success",
            message: "LoggedIn Successfully",
            type: "success",
          });
        } else {
          // alert("Error");
          ElNotification({
            title: "Error",
            message: "Please check your inputs",
            type: "error",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style >
.register {
  margin: 2rem auto;
  max-width: 1100px;
  background: #fff;
  border-radius: 12px;
}

.register .login-section {
  padding: 3rem 6rem 1rem 6rem;
}

.my-btn-register {
  background-color: #7a3d87 !important;
  color: #fff !important;
  border-color: #7a3d87 !important;
  outline-color: #7a3d87 !important;
  width: 100%;
  /* margin-top: -1rem !important; */
  /* margin-bottom: 0.8rem !important; */
}

.my-btn-register:hover {
  background-color: #793d87d5 !important;
  color: #fff !important;
  border-color: #793d87d5 !important;
}

.my-login-link {
  color: #7a3d87 !important;
  text-decoration: none;
}

.my-login-link:hover {
  color: #409eff !important;
}

.register .el-form-item .el-form-item__label {
  padding: 0 !important;
}

.register .el-form-item {
  margin-bottom: 1.5rem !important;
}

.register .el-checkbox__label {
  padding-left: 0.3rem !important;
  white-space: normal;
}

.register .el-checkbox.is-checked .el-checkbox__label {
  color: #7a3d87 !important;
}

.register .el-checkbox__inner:hover {
  border-color: #7a3d87 !important;
}

.register .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #7a3d87 !important;
  border-color: #7a3d87 !important;
}
</style>